import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ControlContainer, NgForm, NgModel } from '@angular/forms';
import { Subject, takeUntil, tap } from 'rxjs';
import { QQQuestionViewModel } from 'src/app/models/qq-question.view-model';
import { ukMask } from 'src/app/services/input-masks';

@Component({
  selector: 'app-tel-no-question',
  templateUrl: './tel-no-question.component.html',
  styleUrls: ['./tel-no-question.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class TelNoQuestionComponent implements OnInit, OnDestroy {
  @Input() question: QQQuestionViewModel;
  @ViewChild('telNo') telNo: NgModel;
  @ViewChild('input') input: ElementRef<HTMLInputElement>;

  dispose$ = new Subject();
  value: string;
  mask = ukMask;

  ngOnInit() {
    this.value = this.question.answer;
    this.question.beforeSubmit(
      this.dispose$,
      e => {
        if (this.input.nativeElement.value != this.value)
          e.add(async () => {
            this.value = this.input.nativeElement.value;
            return await this.save();
          })
      });
  }

  ngOnDestroy(): void {
    this.dispose$.next(null);
  }

  reset() {
    this.value = this.question.answer;
  }

  async save() {
    if (!this.value) {
      this.question.error = "Please enter your phone number";
    } else if (!/^\d{10,12}$/.test(this.value)) {
      this.question.error = "Please enter a valid phone number";
    } else if (!await this.question.setAnswer(this.value, true))
      this.question.error = this.question.error;

    if (this.question.error) {
      this.telNo.control.setErrors({ 'custom': this.question.error });
      return false;
    }
    else
      return true;
  }
}
